<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex class="pr-lg-1" xs12>
                <v-card class="notifications_chart elevation-0 mx-3 mt-6 mb-4" color="#fff">
                    <template v-if="$vuetify.breakpoint.lgAndUp">
                        <v-row class="chart_header px-5 py-7">
                            <v-col cols="8 pl-15">Text</v-col>
                            <v-col cols="2 text-center"> Status</v-col>
                            <v-col cols="2 text-center"> Date</v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <div
                            class="notification_item"
                            v-for="(notification, index) in history.data"
                            :key="index"
                        >
                            <v-row class="chart_content px-5 py-4">
                                <v-col cols="8" class="d-flex justify-center align-center">
                                  {{ notification.body }}
                                </v-col>
                                <v-col cols="2" class="d-flex justify-center align-center">
                                    {{ notification.status }}
                                </v-col>
                                <v-col cols="2" class="d-flex justify-center align-center">
                                    {{ notification.created_at }}
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            class="notification_item"
                            v-for="(notification, index) in history.data"
                            :key="index"
                        >
                            <div
                                class="full_width d-flex flex-column align-center">
                                <div class="full_width px-12 d-flex justify-center mt-4">
                                    <div class="col py-0 text-center">
                                        <div>{{ notification.body }} </div>
                                        <div>{{ notification.created_at }} </div>
                                    </div>
                                </div>

                            </div>
                            <div
                                class="notification_divider mt-7"
                            ></div>
                        </div>
                    </template>
                    <v-row class="d-flex justify-center py-9">
                        <v-btn
                            v-if="history.meta && history.meta.current_page < history.meta.last_page"
                            class="load_btn mt-2"
                            width="189px"
                            height="60px"
                            outlined
                            rounded
                            color="#2C4370"
                            @click="handleLoadNotifications(history.meta.current_page + 1)"
                        >
                            Load more
                        </v-btn>
                    </v-row>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "Notifications",
    data() {
        return {
            notificationStatuses: {
                // mapping of notification status and css class
                'New': 'status_new',
                'In progress': 'status_in_progress',
                'Completed': 'status_completed',
                'Processing': 'status_processing'
            }
        };
    },
    created: function () {
        if (!this.$vuetify.breakpoint.lgAndUp) this.notifications_to_show = 2;
        this.$root.breadcrumbs = [
            {
                text: "Home",
                href: "/dashboard",
            },
            {
                text: "Notifications",
                href: "/notification",
                icon: "../assets/arrow.svg",
            },
        ];
        this.clearNotificationsData();
        this.handleLoadNotifications();
    },

    computed: {
        ...mapGetters('notification', ['history'])
    },
    methods: {
        ...mapActions('notification', ['loadNotifications', 'clearNotificationsData']),
        statusIdToCssClass(id) {
            return id in this.notificationStatuses ? this.notificationStatuses[id] : '';
        },

        handleLoadNotifications(page = 1)
        {
            this.loadNotifications(page);
        }
    }
};
</script>

<style scoped>
.notifications_chart {
    bnotification-radius: 20px !important;
}

.chart_header {
    font-size: 16px;
    font-weight: bold;
    color: #2c4370;
}

.chart_content,
.chart_content a {
    color: #2c4370;
    font-size: 16px;
}

.notification_item,
.notification_item a {
    color: #2c4370;
    font-size: -16px;
    line-height: 1.5em;
}

.chart_content a,
.notification_item a {
    text-decoration: none;
}

.notification_status::before {
    display: block;
    content: "";
    width: 7px;
    height: 7px;
    margin-right: 7px;
    margin-bottom: 1px;
    bnotification-radius: 50%;
}

.notification_status_mobile::before {
    margin-top: 9px;
}

.status_new {
    color: #bcae2d;
}

.status_new::before {
    color: #bcae2d;
}

.status_in_progress {
    color: #bcae2d;
}

.status_in_progress::before {
    background-color: #bcae2d;
}

.status_completed {
    color: #379c41;
}

.status_completed::before {
    background-color: #379c41;
}

.status_processing {
    color: #bcae2d;
}

.status_in_progress::before {
    background-color: #bcae2d;
}

.notification_title {
    font-weight: bold;
}

.full_width {
    width: 100%;
}

.notification_divider {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
}

.load_btn {
    text-transform: none;
    font-size: 18px;
}
</style>
